const mediaItems = [
  {
    title: '【深度解读】2026年娱乐圈大盘点：谁在翻红谁在翻车',
    duration: '18:24',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20video-thumbnail%20style%20illustration%20with%20warm%20coral%20and%20amber%20gradients%2C%20abstract%20spotlight%20and%20film%20elements%2C%20entertainment%20review%20theme%2C%20modern%20editorial%20flat%20design%20with%20soft%20geometric%20accents%2C%20warm%20background&width=640&height=360&seq=media-1-2026&orientation=landscape',
    tag: '盘点分析',
  },
  {
    title: '【现场直击】某品牌发布会全程回顾与行业影响分析',
    duration: '12:05',
    views: '98万',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20event-coverage%20style%20illustration%20with%20warm%20amber%20and%20peach%20gradients%2C%20abstract%20stage%20and%20crowd%20elements%2C%20tech%20event%20theme%2C%20modern%20flat%20design%20with%20soft%20lighting%2C%20warm%20minimal%20background&width=640&height=360&seq=media-2-2026&orientation=landscape',
    tag: '现场报道',
  },
  {
    title: '【吃瓜指南】如何快速辨别网络热门事件的真假信息',
    duration: '08:47',
    views: '87万',
    image: 'https://readdy.ai/api/search-image?query=A%20guide-tutorial%20style%20illustration%20with%20warm%20coral%20gradients%2C%20abstract%20magnifying%20glass%20and%20checkmark%20elements%2C%20fact-checking%20theme%2C%20modern%20editorial%20flat%20design%2C%20warm%20peach%20background%20with%20clean%20geometric%20shapes&width=640&height=360&seq=media-3-2026&orientation=landscape',
    tag: '实用技巧',
  },
  {
    title: '【圆桌讨论】资深媒体人对谈：自媒体时代的吃瓜文化',
    duration: '25:33',
    views: '72万',
    image: 'https://readdy.ai/api/search-image?query=A%20talk-show%20style%20illustration%20with%20warm%20amber%20and%20peach%20gradients%2C%20abstract%20conversation%20bubbles%20and%20panel%20elements%2C%20media%20discussion%20theme%2C%20modern%20flat%20design%20with%20soft%20floating%20shapes%2C%20warm%20background&width=640&height=360&seq=media-4-2026&orientation=landscape',
    tag: '深度对话',
  },
  {
    title: '【一周速览】本周最火爆的十大吃瓜事件总整理',
    duration: '15:20',
    views: '65万',
    image: 'https://readdy.ai/api/search-image?query=A%20news-roundup%20style%20illustration%20with%20warm%20coral%20and%20amber%20gradients%2C%20abstract%20calendar%20and%20numbered%20list%20elements%2C%20weekly%20summary%20theme%2C%20modern%20editorial%20flat%20design%2C%20warm%20peach%20background&width=640&height=360&seq=media-5-2026&orientation=landscape',
    tag: '每周速览',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          视频精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          吃瓜也要有画面感，精选优质视频内容一网打尽
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[180px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <span className="w-5 h-5 flex items-center justify-center text-primary-500 ml-0.5">
                      <i className="ri-play-fill text-xl"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">{item.views} 次观看</span>
              </div>
            </div>
          ))}
          {mediaItems.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[180px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <span className="w-5 h-5 flex items-center justify-center text-primary-500 ml-0.5">
                      <i className="ri-play-fill text-xl"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">{item.views} 次观看</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}